import React from "react";

type BrandedLoadingProps = {
  text?: string;
};

const BrandedLoading: React.FC<BrandedLoadingProps> = ({
  text = "Loading...",
}) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-56px)] bg-white gap-6">
      <img
        src="/assets/brand/CareerSight Logo Print-02.png"
        alt="CareerSight"
        className="w-16 h-16 object-contain animate-pulse"
      />
      <p className="text-body-sm text-text-muted">{text}</p>
    </div>
  );
};

export default BrandedLoading;
